import script from "./RequestStatistics.vue?vue&type=script&setup=true&lang=ts"
export * from "./RequestStatistics.vue?vue&type=script&setup=true&lang=ts"

import "./RequestStatistics.vue?vue&type=style&index=0&id=106d1ca6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-106d1ca6"]])

export default __exports__